import { makeStyles } from '@mui/styles'
import Footer from 'components/Footer/Footer'
import React, { useState } from 'react'
import { LOGO_HEIGHT } from 'theme/constants'
import { Images } from 'theme/Images'
import { theme } from 'theme/theme'
import { Colors } from '../../theme/colors'
import { TranslationButton } from '../NavBar/NavBar'
import { useLayoutStyles } from './useLayoutStyles.hook'
import { useTitle } from './useTitle.hook'

const useClasses = makeStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2),
    },
    backgroundColor: Colors.neutrals[9],
  },
  logoImg: {
    // width: 150,
    height: LOGO_HEIGHT,
    [theme.breakpoints.down('sm')]: {
      height: 60,
    },
  },
})

interface PublicPageLayoutProps {
  title: string
  showTranslationSwitch?: boolean
  children?: React.ReactNode
}

export const PublicPageLayout: React.FunctionComponent<PublicPageLayoutProps> = props => {
  const { root, deco } = useLayoutStyles()
  const { logoImg, header } = useClasses()
  const { title, showTranslationSwitch = false } = props
  const [isOpen, setIsOpen] = useState(false)

  useTitle(title)

  return (
    <div className={root}>
      <div className={deco} />

      <div className={header}>
        <img className={logoImg} src={Images.logoSmallUrl} alt='logo' />

        <TranslationButton
          showTranslationSwitch={showTranslationSwitch}
          open={isOpen}
          handleClose={() => {
            setIsOpen(false)
          }}
          handleOpen={() => {
            setIsOpen(true)
          }}
        />
      </div>

      {props.children}

      <div style={{ flexGrow: 1 }} />
      <Footer />
    </div>
  )
}
